module.exports = "https://cdn.hellotech.com/client-assets/television-and-audio-desktop_c058822bd26a7a465afa205d2be910ee.jpg";